module.exports = __webpack_public_path__ + "static/media/KatnissToDo.6e4e5da9.png";